import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const MoreStoryCard = ({ news }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/blogDetails/${news._id}`)}
      className="
        group
        cursor-pointer
        bg-white
        border
        border-gray-200
        rounded-2xl
        hover:border-[#E94907]
        transition-all
        duration-300
        overflow-hidden
      "
    >
      <div className="flex flex-col sm:flex-row">

        {/* Image */}
        <div className="sm:w-72 flex-shrink-0 overflow-hidden">
          <img
            src={news.cardImage}
            alt={news.title}
            className="
              w-full
              h-52
              sm:h-full
              object-cover
              transition-transform
              duration-500
              group-hover:scale-105
            "
          />
        </div>

        {/* Content */}
        <div className="flex flex-col justify-center flex-1 p-6">

          <h3 className="text-xl md:text-2xl font-bold text-[#0F172A] group-hover:text-[#E94907] transition-colors line-clamp-2">
            {news.title}
          </h3>

          {news.shortDescription && (
            <p className="mt-4 text-gray-600 leading-7 line-clamp-3">
              {news.shortDescription}
            </p>
          )}

          <div className="mt-6 flex items-center text-[#E94907] font-semibold">
            Read More

            <ArrowRight
              size={18}
              className="ml-2 transition-transform duration-300 group-hover:translate-x-1"
            />
          </div>

        </div>

      </div>
    </div>
  );
};

export default MoreStoryCard;